import { ColumnDef } from "@tanstack/react-table";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const EmailCol = (): ColumnDef<AccountTableUser> => ({
  accessorKey: "email",
  header: "Email",
  cell: ({ row }) => (
    <span className="block break-all">{row.original.email}</span>
  ),
});
